import Vue from 'vue';
import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';

Swiper.use([Pagination, Navigation, Autoplay]);

Vue.component('image-slider', {
    data() {
        return {
            currentIndex: 0,
            swiperSlider: null,
        };
    },

    props: {
        numberOfSlides: {
            type: Number,
        },
    },

    computed: {
        humanReadableIndex: function () {
            if (this.currentIndex < 9) {
                return `0${this.currentIndex + 1}`;
            }

            return this.currentIndex + 1;
        },

        formattedLength: function () {
            const length = this.numberOfSlides;

            if (length < 10) {
                return `0${length}`;
            }

            return length;
        },
    },

    mounted() {
        this.initSwiper();
    },

    methods: {
        initSwiper() {
            this.swiperSlider = new Swiper('.swiper-container', {
                slidesPerView: 1,
                direction: 'horizontal',
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: true,
                },
                loop: true,
                on: {
                    slideChange: (swiper) => {
                        this.currentIndex = swiper.realIndex;
                    },
                },
                navigation: {
                    nextEl: '.image-slider-next',
                    prevEl: '.image-slider-prev',
                },
            });
        },
    },
});
